import axios from "axios";

const api = axios.create({
    //baseURL: "http://127.0.0.1:8000", ////////////////////////////////////////////////////// URL de l'API
    baseURL: "http://yannoch.synology.me:8080", ////////////////////////////////////////////////////// URL de l'API
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

//const API_IMG = "http://127.0.0.1:8000/storage/" //////////////////////////////////////////////// URL des images de l'API
const API_IMG = "http://yannoch.synology.me:8080/storage/" //////////////////////////////////////////////// URL des images de l'API

export const resolveImageSrc = (picture) => {
    if (!picture) return null;
    if (/^(blob:|https?:\/\/)/.test(picture)) return picture;
    return `${API_IMG}${picture}`;
};

// Request : ajoute le token actuel
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Helper pour refresh (utilise axios natif pour éviter boucle)
async function refreshToken() {
    try {
        const current = localStorage.getItem("token");
        if (!current) throw new Error("No token to refresh");
        const res = await api.post("http://127.0.0.1:8000/api/refresh", {}, {
            //const res = await axios.post("http://192.168.1.39:8080/api/refresh", {}, {
            headers: { Authorization: `Bearer ${current}` },
        });
        // backend doit renvoyer { token: "..." }
        const newToken = res.data?.token;
        if (!newToken) throw new Error("Refresh returned no token");
        // sauvegarde le token
        localStorage.setItem("token", newToken);
        // met à jour default header de l'instance api
        api.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
        return newToken;
    } catch (err) {
        throw err;
    }
}

// Response : si 401 on tente refresh une fois, puis on rejoue
api.interceptors.response.use(
    (resp) => resp,
    async (error) => {
        const originalRequest = error.config;
        if (!originalRequest) return Promise.reject(error);

        // protection contre boucle infinie
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const newToken = await refreshToken();
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return api(originalRequest);
            } catch (err) {
                // refresh failed -> redirection accueil
                localStorage.removeItem("token");
                delete api.defaults.headers.common["Authorization"];
                window.location.href = "/";
                return Promise.reject(err);
            }
        }

        return Promise.reject(error);
    }
);

export default api;
